var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.68594 0 0 2.68594 0 6C0 9.31406 2.68594 12 6 12C9.31406 12 12 9.31406 12 6C12 2.68594 9.31406 0 6 0ZM6 10.875C3.31172 10.875 1.125 8.68805 1.125 6C1.125 3.31195 3.31172 1.125 6 1.125C8.68828 1.125 10.875 3.31195 10.875 6C10.875 8.68805 8.68828 10.875 6 10.875ZM6.9375 7.875H6.5625V5.8125C6.5625 5.50313 6.31172 5.25 6 5.25H5.25C4.94063 5.25 4.6875 5.50313 4.6875 5.8125C4.6875 6.12187 4.94063 6.375 5.25 6.375H5.4375V7.875H5.0625C4.75313 7.875 4.5 8.12813 4.5 8.4375C4.5 8.74687 4.75313 9 5.0625 9H6.9375C7.24805 9 7.5 8.74805 7.5 8.4375C7.5 8.12695 7.24922 7.875 6.9375 7.875ZM6 4.5C6.41414 4.5 6.75 4.16414 6.75 3.75C6.75 3.33586 6.41414 3 6 3C5.58586 3 5.25 3.33516 5.25 3.75C5.25 4.16484 5.58516 4.5 6 4.5Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.06b3a3668f554f15776e18d7536e4e49.svg";
export { ForwardRef as ReactComponent };